import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from "@mui/icons-material/People";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PersonIcon from "@mui/icons-material/Person";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DescriptionIcon from "@mui/icons-material/Description";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import BugReportIcon from '@mui/icons-material/BugReport';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SearchIcon from '@mui/icons-material/Search';
import LogoutIcon from '@mui/icons-material/Logout';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [openClientes, setOpenClientes] = useState(false);
  const [openCreditos, setOpenCreditos] = useState(false);

  // Auto-expandir submenús según la ruta activa
  useEffect(() => {
    if (currentPath.startsWith('/clients') || currentPath === '/search/clients') {
      setOpenClientes(true);
    }
    if (currentPath.startsWith('/credits') || currentPath === '/search/credits') {
      setOpenCreditos(true);
    }
  }, [currentPath]);

  // ─── Auth: MISMA lógica exacta del Sidebar original ───
  const token = window.sessionStorage.getItem('localToken');
  const username = window.sessionStorage.getItem('username');
  let roleId = null;
  try {
    if (token) roleId = JSON.parse(atob(token.split('.')[1])).roleId;
  } catch (e) {
    roleId = null;
  }

  const handleClickClientes = () => {
    setOpenClientes(!openClientes);
  };

  const handleClickCreditos = () => {
    setOpenCreditos(!openCreditos);
  };

  // ─── Estilos del mockup (minimalista, fondo blanco, acentos rojos sutiles) ───
  const itemStyle = (isActive) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.85rem',
    width: '100%',
    padding: '0.62rem 0.85rem',
    borderRadius: '10px',
    border: 'none',
    borderLeft: isActive ? '3px solid #D71920' : '3px solid transparent',
    background: isActive ? '#FEF3F2' : 'transparent',
    color: isActive ? '#111111' : '#344054',
    fontSize: '0.86rem',
    fontWeight: isActive ? 600 : 500,
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.16s ease',
    position: 'relative',
    fontFamily: 'inherit'
  });

  const subItemStyle = (isActive) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.55rem',
    width: '100%',
    padding: '0.45rem 0.85rem 0.45rem 2.25rem',
    borderRadius: '8px',
    border: 'none',
    background: isActive ? 'rgba(215, 25, 32, 0.05)' : 'transparent',
    color: isActive ? '#D71920' : '#667085',
    fontSize: '0.82rem',
    fontWeight: isActive ? 600 : 500,
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.16s ease',
    fontFamily: 'inherit'
  });

  const hoverEnter = (e, isActive) => {
    if (!isActive) {
      e.currentTarget.style.background = '#F9FAFB';
      e.currentTarget.style.color = '#111111';
    }
  };

  const hoverLeave = (e, isActive) => {
    if (!isActive) {
      e.currentTarget.style.background = 'transparent';
      e.currentTarget.style.color = '#344054';
    }
  };

  return (
    <aside style={{
      width: '260px',
      minWidth: '260px',
      background: '#FFFFFF',
      borderRight: '1px solid #EAECF0',
      display: 'flex',
      flexDirection: 'column',
      padding: '1.25rem 0.85rem',
      gap: '0.25rem',
      overflowY: 'auto',
      height: '100%'
    }}>
      {/* Etiqueta de Sección */}
      <div style={{
        padding: '0.4rem 0.85rem 0.65rem',
        fontSize: '0.68rem',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#98A2B3',
        fontWeight: 700
      }}>
        Módulos Mobilia
      </div>

      {/* 1. Inicio / Dashboard */}
      <button
        style={itemStyle(currentPath === '/home')}
        onClick={() => navigate("/home")}
        onMouseEnter={(e) => hoverEnter(e, currentPath === '/home')}
        onMouseLeave={(e) => hoverLeave(e, currentPath === '/home')}
      >
        <DashboardIcon style={{ 
          fontSize: '1.15rem', 
          color: currentPath === '/home' ? '#D71920' : '#667085' 
        }} />
        <span>Inicio</span>
      </button>

      {/* 2. Clientes (Desplegable) — mismas rutas exactas: /clients y /search/clients */}
      <div>
        <button
          style={itemStyle(currentPath.startsWith('/clients') || currentPath === '/search/clients')}
          onClick={handleClickClientes}
          onMouseEnter={(e) => hoverEnter(e, currentPath.startsWith('/clients'))}
          onMouseLeave={(e) => hoverLeave(e, currentPath.startsWith('/clients'))}
        >
          <PeopleIcon style={{ 
            fontSize: '1.15rem', 
            color: (currentPath.startsWith('/clients') || currentPath === '/search/clients') ? '#D71920' : '#667085' 
          }} />
          <span style={{ flex: 1 }}>Clientes</span>
          {openClientes ? (
            <ExpandLess style={{ fontSize: '1.05rem', color: '#98A2B3' }} />
          ) : (
            <ExpandMore style={{ fontSize: '1.05rem', color: '#98A2B3' }} />
          )}
        </button>

        {openClientes && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.15rem', marginTop: '0.15rem', marginBottom: '0.25rem', borderLeft: '1px solid #EAECF0', marginLeft: '1.35rem' }}>
            <button
              style={subItemStyle(currentPath === '/clients')}
              onClick={() => navigate("/clients")}
              onMouseEnter={(e) => { if (currentPath !== '/clients') { e.currentTarget.style.color = '#111111'; e.currentTarget.style.background = '#F9FAFB'; } }}
              onMouseLeave={(e) => { if (currentPath !== '/clients') { e.currentTarget.style.color = '#667085'; e.currentTarget.style.background = 'transparent'; } }}
            >
              <AddCircleOutlineIcon style={{ fontSize: '0.85rem' }} />
              <span>Crear</span>
            </button>
            <button
              style={subItemStyle(currentPath === '/search/clients')}
              onClick={() => navigate("/search/clients")}
              onMouseEnter={(e) => { if (currentPath !== '/search/clients') { e.currentTarget.style.color = '#111111'; e.currentTarget.style.background = '#F9FAFB'; } }}
              onMouseLeave={(e) => { if (currentPath !== '/search/clients') { e.currentTarget.style.color = '#667085'; e.currentTarget.style.background = 'transparent'; } }}
            >
              <SearchIcon style={{ fontSize: '0.85rem' }} />
              <span>Consultar</span>
            </button>
          </div>
        )}
      </div>

      {/* 3. Créditos (Desplegable) — mismas rutas exactas: /credits y /search/credits */}
      <div>
        <button
          style={itemStyle(currentPath.startsWith('/credits') || currentPath === '/search/credits')}
          onClick={handleClickCreditos}
          onMouseEnter={(e) => hoverEnter(e, currentPath.startsWith('/credits'))}
          onMouseLeave={(e) => hoverLeave(e, currentPath.startsWith('/credits'))}
        >
          <AttachMoneyIcon style={{ 
            fontSize: '1.15rem', 
            color: (currentPath.startsWith('/credits') || currentPath === '/search/credits') ? '#D71920' : '#667085' 
          }} />
          <span style={{ flex: 1 }}>Créditos</span>
          {openCreditos ? (
            <ExpandLess style={{ fontSize: '1.05rem', color: '#98A2B3' }} />
          ) : (
            <ExpandMore style={{ fontSize: '1.05rem', color: '#98A2B3' }} />
          )}
        </button>

        {openCreditos && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.15rem', marginTop: '0.15rem', marginBottom: '0.25rem', borderLeft: '1px solid #EAECF0', marginLeft: '1.35rem' }}>
            <button
              style={subItemStyle(currentPath === '/credits')}
              onClick={() => navigate("/credits")}
              onMouseEnter={(e) => { if (currentPath !== '/credits') { e.currentTarget.style.color = '#111111'; e.currentTarget.style.background = '#F9FAFB'; } }}
              onMouseLeave={(e) => { if (currentPath !== '/credits') { e.currentTarget.style.color = '#667085'; e.currentTarget.style.background = 'transparent'; } }}
            >
              <AddCircleOutlineIcon style={{ fontSize: '0.85rem' }} />
              <span>Crear</span>
            </button>
            <button
              style={subItemStyle(currentPath === '/search/credits')}
              onClick={() => navigate("/search/credits")}
              onMouseEnter={(e) => { if (currentPath !== '/search/credits') { e.currentTarget.style.color = '#111111'; e.currentTarget.style.background = '#F9FAFB'; } }}
              onMouseLeave={(e) => { if (currentPath !== '/search/credits') { e.currentTarget.style.color = '#667085'; e.currentTarget.style.background = 'transparent'; } }}
            >
              <SearchIcon style={{ fontSize: '0.85rem' }} />
              <span>Consultar</span>
            </button>
          </div>
        )}
      </div>

      {/* 4. Usuarios — misma ruta: /users */}
      <button
        style={itemStyle(currentPath === '/users')}
        onClick={() => navigate("/users")}
        onMouseEnter={(e) => hoverEnter(e, currentPath === '/users')}
        onMouseLeave={(e) => hoverLeave(e, currentPath === '/users')}
      >
        <PersonIcon style={{ 
          fontSize: '1.15rem', 
          color: currentPath === '/users' ? '#D71920' : '#667085' 
        }} />
        <span>Usuarios</span>
      </button>

      {/* 5. Valores UVR — misma ruta: /uvr */}
      <button
        style={itemStyle(currentPath === '/uvr')}
        onClick={() => navigate("/uvr")}
        onMouseEnter={(e) => hoverEnter(e, currentPath === '/uvr')}
        onMouseLeave={(e) => hoverLeave(e, currentPath === '/uvr')}
      >
        <TrendingUpIcon style={{ 
          fontSize: '1.15rem', 
          color: currentPath === '/uvr' ? '#D71920' : '#667085' 
        }} />
        <span>Valores UVR</span>
      </button>

      {/* 6. Informes — misma ruta: /documents */}
      <button
        style={itemStyle(currentPath === '/documents')}
        onClick={() => navigate("/documents")}
        onMouseEnter={(e) => hoverEnter(e, currentPath === '/documents')}
        onMouseLeave={(e) => hoverLeave(e, currentPath === '/documents')}
      >
        <DescriptionIcon style={{ 
          fontSize: '1.15rem', 
          color: currentPath === '/documents' ? '#D71920' : '#667085' 
        }} />
        <span>Informes</span>
      </button>

      {/* 7. Cierre de periodo — misma ruta: /closedPeriods */}
      <button
        style={itemStyle(currentPath === '/closedPeriods')}
        onClick={() => navigate("/closedPeriods")}
        onMouseEnter={(e) => hoverEnter(e, currentPath === '/closedPeriods')}
        onMouseLeave={(e) => hoverLeave(e, currentPath === '/closedPeriods')}
      >
        <EventAvailableIcon style={{ 
          fontSize: '1.15rem', 
          color: currentPath === '/closedPeriods' ? '#D71920' : '#667085' 
        }} />
        <span>Cierre de periodo</span>
      </button>

      {/* 8. Superadministrador: Logs y Debug — MISMA condición exacta: roleId === 1 && username === 'complemento360' */}
      {roleId === 1 && username === 'complemento360' && (
        <>
          <div style={{
            height: '1px',
            background: '#EAECF0',
            margin: '0.65rem 0.5rem 0.45rem'
          }} />

          <div style={{
            padding: '0.2rem 0.85rem 0.4rem',
            fontSize: '0.65rem',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: '#98A2B3',
            fontWeight: 700
          }}>
            Superadministrador
          </div>

          {/* Logs — misma ruta: /logs */}
          <button
            style={itemStyle(currentPath === '/logs')}
            onClick={() => navigate("/logs")}
            onMouseEnter={(e) => hoverEnter(e, currentPath === '/logs')}
            onMouseLeave={(e) => hoverLeave(e, currentPath === '/logs')}
          >
            <BugReportIcon style={{ 
              fontSize: '1.15rem', 
              color: currentPath === '/logs' ? '#D71920' : '#667085' 
            }} />
            <span>Logs</span>
          </button>

          {/* Debug — misma ruta: /debug */}
          <button
            style={itemStyle(currentPath === '/debug')}
            onClick={() => navigate("/debug")}
            onMouseEnter={(e) => hoverEnter(e, currentPath === '/debug')}
            onMouseLeave={(e) => hoverLeave(e, currentPath === '/debug')}
          >
            <AssessmentIcon style={{ 
              fontSize: '1.15rem', 
              color: currentPath === '/debug' ? '#D71920' : '#667085' 
            }} />
            <span>Debug</span>
          </button>
        </>
      )}

      {/* Sesión y Logout */}
      <div style={{
        marginTop: 'auto',
        padding: '0.75rem 0.5rem 0.25rem',
        borderTop: '1px solid #EAECF0',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }}>
        {/* Usuario actual */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.6rem',
          padding: '0.5rem 0.65rem',
          borderRadius: '10px',
          background: '#F9FAFB'
        }}>
          <div style={{
            width: '30px',
            height: '30px',
            borderRadius: '8px',
            background: 'linear-gradient(135deg, #D71920 0%, #0f172a 100%)',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem',
            fontWeight: 700,
            flexShrink: 0
          }}>
            {(username || 'U').charAt(0).toUpperCase()}
          </div>
          <div style={{ overflow: 'hidden', flex: 1 }}>
            <div style={{ fontSize: '0.80rem', fontWeight: 600, color: '#101828', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {username || 'Usuario'}
            </div>
            <div style={{ fontSize: '0.68rem', color: '#98A2B3', fontWeight: 500 }}>
              {roleId === 1 ? 'Administrador' : 'Operador'}
            </div>
          </div>
        </div>

        {/* Botón Cerrar Sesión */}
        <button
          onClick={() => {
            sessionStorage.clear();
            sessionStorage.setItem("loggedIn", false);
            window.location.href = '/login';
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.6rem',
            width: '100%',
            padding: '0.55rem 0.85rem',
            borderRadius: '10px',
            border: '1px solid #EAECF0',
            background: '#FFFFFF',
            color: '#667085',
            fontSize: '0.84rem',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.16s ease',
            fontFamily: 'inherit'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#FEF3F2';
            e.currentTarget.style.borderColor = '#FECDCA';
            e.currentTarget.style.color = '#D71920';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#FFFFFF';
            e.currentTarget.style.borderColor = '#EAECF0';
            e.currentTarget.style.color = '#667085';
          }}
        >
          <LogoutIcon style={{ fontSize: '1rem' }} />
          <span>Cerrar Sesión</span>
        </button>

        {/* Versión */}
        <div style={{ fontSize: '0.68rem', color: '#98A2B3', padding: '0.15rem 0.35rem', display: 'flex', flexDirection: 'column', gap: '0.1rem' }}>
          <span style={{ fontWeight: 600, color: '#344054' }}>Mobilia v1.0.5</span>
          <span>Complemento 360 SAS</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;